import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useRef, useState } from 'react';

const CreaPuesto = ({proyecto, onSave}) => {
    const [sigla, setSigla] = useState('');
    const [nombrePues, setNombrePues] = useState('');
    const [codRapido, setCodRapido] = useState('');
    const [telefono, setTelefono] =  useState('');
    const [procesa, setProcesa] = useState(false);

    const toastPuesto = useRef()

    const handleGuardar = () => {
      if (sigla.length === 0 || nombrePues.length === 0) {
            toastPuesto.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe llenar los campos Sigla y Nombre del puesto' });
            return;
        }
        setProcesa(true);
        const dataGuardar = {
            proyecto: proyecto.proyectoId,
            sigla: sigla.toUpperCase(),
            nombre: nombrePues.toUpperCase(),
            codRapido: codRapido,
            telefono: telefono
        };
        onSave(dataGuardar);
    };

    return (
        <div className="card">
          <Toast ref={toastPuesto} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-6">
                    <label>Sigla Puesto: </label>
                    <InputText value={sigla} onChange={(evt) => setSigla(evt.target.value)} placeholder="Sigla para el Puesto" disabled={procesa} style={{ textTransform: 'uppercase' }} maxLength={50} />
                </div>
                <div className="field col-12 md:col-6">
                    <label>Nombre Puesto: </label>
                    <InputText value={nombrePues} onChange={(evt) => setNombrePues(evt.target.value)} placeholder="Nombre para el Puesto" disabled={procesa} style={{ textTransform: 'uppercase' }} maxLength={100} />
                </div>
                <div className="field col-12 md:col-6">
                  <label>Cod Marcado Rapido: </label>
                  <InputText value={codRapido} onChange={(evt) => setCodRapido(evt.target.value)} placeholder="Codigo Marcado Rapido" disabled={procesa} style={{ textTransform: 'uppercase' }} maxLength={50} />
                </div>
                <div className="field col-12 md:col-6">
                  <label>Telefono: </label>
                  <InputText value={telefono} onChange={(evt) => setTelefono(evt.target.value)} placeholder="Marcado Rapido" disabled={procesa} style={{ textTransform: 'uppercase' }} maxLength={100} />
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                <div className="field col-12 md:col-6">
                    <Button label="Guardar" onClick={handleGuardar} loading={procesa} />
                </div>
            </div>
        </div>
    );
};

export default CreaPuesto;
